import ValidationsRepository from "./validationsRepository";
import PricingRepository from "./pricingRepository";
import PaymentRepository from "./paymentRepository";
import InvoicingRepository from "./invoicingRepository";
import SchedulerRepository from "./schedulerRepository";
import GeoRepository from "./geoRepository";
import GatewayRepository from "./gatewayRepository";
import VehicleRepository from "./vehicleRepository";
import CompanyRepository from "./companyRepository";
import FleetRepository from "./fleetRepository";
import DriverRepository from "./driverRepository";
import BookingRepository from "./bookingRepository";
import DispatchingRepository from "./dispatchingRepository";
import TripRepository from "./tripRepository";
import InvoiceRuleRepository from "./InvoiceRuleRepository";
import UserManagementRepository from "./userManagementRepository";
import AvailabilityRepository from "./availabilityRepository";
import ProvisionBatchRepository from "./provisionBatchRepository";
import KelaBatchRepository from "./kelaBatchRepository";
import ProcessRunRepository from "./processRunRepository";

const repositories = {
    validations: ValidationsRepository,
    pricing: PricingRepository,
    payment: PaymentRepository,
    invoicing: InvoicingRepository,
    cronScheduler: SchedulerRepository,
    invoiceRule: InvoiceRuleRepository,
    geo: GeoRepository,
    vehicle: VehicleRepository,
    company: CompanyRepository,
    fleet: FleetRepository,
    driver: DriverRepository,
    userManagement: UserManagementRepository,
    availability: AvailabilityRepository,
    gateway: GatewayRepository,
    booking: BookingRepository,
    dispatching: DispatchingRepository,
    trip: TripRepository,
    provisionBatch: ProvisionBatchRepository,
    kelaBatch: KelaBatchRepository,
    processRun: ProcessRunRepository
};

export const RepositoryFactory = {
    get: name => repositories[name]
};
